module.exports = __webpack_public_path__ + "img/Webbing_1200x800.b32812ca.png";